const round = (value) => Math.round(value * 100) / 100;
const phase = (value, size) => round(((value % size) + size) % size) % size;

// All coordinates are original-image pixels, independent of canvas pan/zoom.
export class ManualGrid {
  constructor(width, height) {
    this.width = width;
    this.height = height;
    this.verticals = [];
    this.error = '';
  }

  get instruction() {
    return (
      this.error ||
      [
        '1 of 3: Click the first vertical grid line.',
        '2 of 3: Click the next vertical grid line, one cell away.',
        '3 of 3: Align the two horizontal lines with a grid row, then click. Their spacing matches the cell size.'
      ][this.verticals.length]
    );
  }

  contains(point) {
    return (
      point &&
      Number.isFinite(point.x) &&
      Number.isFinite(point.y) &&
      point.x >= 0 &&
      point.y >= 0 &&
      point.x <= this.width &&
      point.y <= this.height
    );
  }

  place(point) {
    if (!this.contains(point)) {
      this.error = 'Choose a line inside the map image.';
      return null;
    }
    this.error = '';
    if (!this.verticals.length) {
      this.verticals.push(round(point.x));
    } else if (this.verticals.length === 1) {
      const size = round(Math.abs(point.x - this.verticals[0]));
      if (size < 1 || size > this.height) {
        this.error = 'Choose the next vertical line at least 1 pixel away, with room for a square cell.';
        return null;
      }
      this.size = size;
      this.verticals.push(round(point.x));
    } else {
      return {
        grid_size: this.size,
        grid_offset_x: phase(Math.min(...this.verticals), this.size),
        grid_offset_y: phase(Math.min(point.y, this.height - this.size), this.size)
      };
    }
    return null;
  }

  preview(point) {
    const verticals = [...this.verticals];
    const horizontal = [];
    let square = null;
    if (this.contains(point)) {
      if (verticals.length < 2) verticals.push(point.x);
      else {
        const y = Math.min(point.y, this.height - this.size);
        horizontal.push(y, y + this.size);
        square = { x: Math.min(...verticals), y, width: this.size, height: this.size };
      }
    }
    return {
      lines: [...verticals.map((x) => [x, 0, x, this.height]), ...horizontal.map((y) => [0, y, this.width, y])],
      square
    };
  }
}
